import { IAuthClient } from "@micro-frontend-react/employee-experience/lib/IAuthClient";
import { extractRolesFromJWT } from '../Services/UserRolesService';
import { getUserRoles } from '../Services/UserRoleConfig';
export async function acquireToken(
    authClient: IAuthClient | null,
    setToken: (token: string | null) => void,
    dispatch: any,
    clearUserRolesAction: any
): Promise<void> {
    if (authClient) {
        try {
            const accessToken = await authClient.acquireToken(__SCOPES__);
            setToken(accessToken);
        } catch (error) {
            setToken(null);
            dispatch(clearUserRolesAction());
        }
    }
}

export async function processTokenRoles(
    token: string | null,
    dispatch: any,
    setUserRolesAction: any,
    clearUserRolesAction: any,
    reportList?: any | null
): Promise<void> {
    if (token && token !== null) {
        try {
            const tokenRoles = await extractRolesFromJWT(token);
            const extractedRoles =await getUserRoles(tokenRoles, reportList);
            dispatch(setUserRolesAction(extractedRoles));
        } catch (error) {
            dispatch(clearUserRolesAction());
        }
    }
}
